<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-tag"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col cols="12" class="text-right mb-5">
          <v-btn
              class="btn-add-templates"
              @click="addTags"
          >
            Add Tags
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="white mx-1">
        <v-col cols="12" class="mt-n2">
          <v-data-table
              :headers="headers"
              :items="tags"
              class="elevation-1"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item.id)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
          <v-dialog
              v-model="dialogAddTag"
              v-if="dialogAddTag"
              max-width="500px"
              persistent
          >
            <v-card class="pa-4">
              <v-card-title>
                <span class="text-h5 mx-3">Add Tag</span>
              </v-card-title>
              <v-card-text>
                <v-row align="center" justify="center">
                  <v-col class="mt-4" cols="11">
                    <div class="mb-2 primary--text">Name<span class="necessary">(*)</span></div>
                    <v-text-field
                        filled
                        label="Name"
                        placeholder="Enter name"
                        v-model="name"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-row align="center" justify="center" class="mb-4">
                  <v-btn class="mr-5" @click="dialogAddTag = false">CANCEL</v-btn>
                  <v-btn class="btn" @click="save">SAVE</v-btn>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
              v-model="dialogEditTag"
              v-if="dialogEditTag"
              max-width="500px"
              persistent
          >
            <v-card class="pa-4">
              <v-card-title>
                <span class="text-h5 mx-3">Edit Tag</span>
              </v-card-title>
              <v-card-text>
                <v-row align="center" justify="center">
                  <v-col class="mt-4" cols="11">
                    <div class="mb-2 primary--text">Name<span class="necessary">(*)</span></div>
                    <v-text-field
                        filled
                        label="Name"
                        placeholder="Enter name"
                        v-model="tagDetail.name"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-row align="center" justify="center" class="mb-4">
                  <v-btn class="mr-5" @click="dialogEditTag = false">CANCEL</v-btn>
                  <v-btn class="btn" @click="update">UPDATE</v-btn>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import {DELETE_TAGS, GET_DETAIL_TAGS, GET_LIST_TAGS, SAVE_TAGS, UPDATE_TAGS} from "@/store/modules/tags";

export default {
  name: "Tags",
  data() {
    return {
      page: "Tags",
      breadcrumbs: [
        {
          text: "Templates Setting",
          disabled: true,
        },
        {
          text: "Tags",
          disabled: false,
        },
      ],
      headers: [
        {text: "ID", value: "id", align: "start"},
        {text: "Name", value: "name"},
        {text: "Actions", value: "actions", sortable: false},
      ],
      dialogAddTag: false,
      dialogEditTag: false,
      name: '',
    }
  },
  computed: {
    ...mapGetters({
      tags: "tags",
      tagDetail: "tagDetail",
    })
  },
  async created() {
    await this.$store.dispatch(GET_LIST_TAGS);
  },
  methods: {
    editItem(id) {
      this.$store.dispatch(`${GET_DETAIL_TAGS}`, id).then((data) => {
        if (data) {
          this.dialogEditTag = true;
        }
      });
    },
    deleteItem(id) {
      confirm('Are you sure you want to delete ?') &&
      this.$store.dispatch(`${DELETE_TAGS}`, id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(GET_LIST_TAGS);
        }
      })
    },
    addTags() {
      this.dialogAddTag = true
    },
    async update() {
      await this.$store.dispatch(`${UPDATE_TAGS}`, this.tagDetail).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Update successful!', {
            duration: 1000,
            position: 'top-center'
          })
          this.dialogEditTag = false
          this.$store.dispatch(GET_LIST_TAGS);
        } else {
          alert(data.data.errors)
        }
      });
    },
    async save() {
      if (this.name == '') {
        alert("Name is empty")
      } else {
        let data = {
          name: this.name
        }
        await this.$store.dispatch(`${SAVE_TAGS}`, data).then((data) => {
          if (data.data.status == 1) {
            this.$toasted.success('Update successful!', {
              duration: 1000,
              position: 'top-center'
            })
            this.dialogAddTag = false
            this.name = ''
            this.$store.dispatch(GET_LIST_TAGS);
          } else {
            alert(data.data.errors)
          }
        });
      }


    }
  }
}
</script>

<style scoped>
.btn-add-templates {
  background-color: #71BEC8 !important;
  color: white !important;
  border-radius: 36px !important;
}

.btn {
  background-color: #71BEC8 !important;
  color: white !important;
}
.necessary {
  color: red;
}

</style>